<template>
  <div id="ylAboutCarousel">
    <ylAboutCarouselMobile v-if="isMobileScreen" :list="list" />
    <ylAboutCarouselPC v-else :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylAboutCarousel",
  components: {
    ylAboutCarouselMobile: () => import("./components/mobile.vue"),
    ylAboutCarouselPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: []
    };
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.coreTeamBanner();
  },
  methods: {
    async coreTeamBanner() {
      let res = await this.$api.coreTeamBanner();
      this.list = res
    },
  },
};
</script>